import { SummationGroupDataService } from "../../core/summationgroups.dataservice";
import { Ng2StateDeclaration } from "@uirouter/angular";
import { SummationGroups } from "./summation-groups.component";
import { EditSummationGroup } from "./summation-group.edit.component";
import { SummationGroup } from "./summation-group.component";

/**
 * This state displays all Summation Groups
 */
export const summationGroupsState: Ng2StateDeclaration = {
    name: "app.settings.summationgroups",
    url: "/summationgroups",
    views: {
        "main-view@app": {
            component: SummationGroups
        }
    },
    resolve: {
        summationGroups: [SummationGroupDataService.Id, (summationGroupDataService: SummationGroupDataService) => {
            return summationGroupDataService.getAll();
        }]
    }
};

/**
 * This state is for creating a new Summation Group
 */
export const newSummationGroupState: Ng2StateDeclaration = {
    name: "app.settings.summationgroups.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: EditSummationGroup
        }
    },
    resolve: {
        summationGroup: function () {
            return <Nema.Crew.Model.ActivityTypeSummationGroup>{ Id: -1, Name: "", Active: true, SortTag: "", ActivityTypeSummationGroupMapping: [] };
        },
        isNew: function () {
            return true;
        }
    }
};

/**
 * This state is for editing a Summation Group
 */
export const editSummationGroupState: Ng2StateDeclaration = {
    name: "app.settings.summationgroups.edit",
    url: "/{id:int}/edit",
    views: {
        "main-view@app": {
            component: EditSummationGroup
        }
    },
    resolve: {
        summationGroup: [SummationGroupDataService.Id, "$stateParams", function (summationGroupDataService: SummationGroupDataService, $stateParams) {
            return summationGroupDataService.get($stateParams.id);
        }],
        isNew: function () {
            return false;
        }
    }
};

/**
 * Summation Group Details state
 */
export const summationGroupState: Ng2StateDeclaration = {
    name: "app.settings.summationgroups.detail",
    url: "/{id:int}",
    views: {
        "main-view@app": {
            component: SummationGroup
        }
    },
    resolve: {
        summationGroup: [SummationGroupDataService.Id, "$stateParams", function (summationGroupDataService: SummationGroupDataService, $stateParams) {
            return summationGroupDataService.get($stateParams.id);
        }]
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/summationgroups/summation-groups.states.ts